import React from 'react';
import { Button, Box } from '@acast/decibel';
import { Episode } from 'client/resources';
import DateSelect from 'shared/components/date-select';
import TimeSelect from 'shared/components/time-select';
import moment from 'moment';
import resourceProp from 'shared/helpers/resource-prop';
import updateEntity from 'app/entity/actions/update';
import { isEpisodeBeingPublished, adjustAcastPlusConditionsToPublishDate } from 'resources/episode';

const PublishDateSelect = ({ episode }) => {
  const { publishDate } = episode.data;
  const pending = isEpisodeBeingPublished(episode.data.id);

  function onPublishDateChange(value) {
    const original = moment(publishDate);
    const dateAndTime = moment(value);

    if (original.isValid()) {
      dateAndTime.hours(original.hours()).minutes(original.minutes());
    }

    if (dateAndTime.isValid()) {
      updateEntity(
        Episode,
        episode.data.merge({
          publishDate: dateAndTime.toISOString(),
        })
      ).then(() => adjustAcastPlusConditionsToPublishDate(episode.data.id));
    }
  }

  function onPublishTimeChange(value) {
    if (moment(value).isValid()) {
      updateEntity(
        Episode,
        episode.data.merge({
          publishDate: value.toISOString(),
        })
      ).then(() => adjustAcastPlusConditionsToPublishDate(episode.data.id));
    }
  }

  function setPublishDateAndTimeToNow() {
    const now = moment();
    onPublishTimeChange(now);
  }

  return (
    <Box alignItems="flex-end" gap={4} mb={8}>
      <div>
        <DateSelect
          label="Publish Date"
          selected={publishDate}
          onChange={onPublishDateChange}
          disabled={pending}
        />
      </div>
      <div>
        <TimeSelect
          label="Time"
          selected={publishDate}
          onChange={onPublishTimeChange}
          disabled={pending}
        />
      </div>
      <Button variant="tertiary" intent="primary" onClick={setPublishDateAndTimeToNow}>
        Set date/time to now
      </Button>
    </Box>
  );
};

PublishDateSelect.propTypes = {
  episode: resourceProp(Episode),
};

export default PublishDateSelect;
